import { Formik, FormikHelpers } from 'formik'
import { Button, InputField } from '../../../../components'
import { resetPassword } from '../../api'
import { useAppDispatch, useAppSelector } from '../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { ResetPasswordSchema } from '../../schema'
import { ResetPasswordFormPropsType, ResetPasswordFormValues } from '../../type'
import { useTranslation } from 'react-i18next'

const ResetPasswordForm = ({ onSuceess }: ResetPasswordFormPropsType) => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { email } = useAppSelector((state) => state.persistedReducers.user)
    const params = new URLSearchParams(document.location.search)
    const token = params.get('Token') // is the string "Jonathan"

    const handleResetPassword = async (
        values: ResetPasswordFormValues,
        actions: FormikHelpers<ResetPasswordFormValues>
    ) => {
        const form = {
            password: values.password,
            email: values.email,
            token: decodeURIComponent(`${token}`).replaceAll(' ', '+'),
        }
        dispatch(SHOW_LOADER())
        try {
            const resetResponse = await resetPassword(form)
            const response = resetResponse?.data
            if (response) {
                dispatch(
                    SHOW_NOTIFICATION({
                        message: response,
                        type: 'success',
                    })
                )
                dispatch(HIDE_LOADER())

                onSuceess(true)
            }
            actions.setSubmitting(false)
        } catch (error: any) {
            if (error.response.status === 500) {
                dispatch(
                    SHOW_NOTIFICATION({
                        message: 'Link expired or already used',
                        type: 'error',
                    })
                )
            }
        }
    }
    return (
        <div className="auth-form">
            <Formik
                initialValues={{
                    password: '',
                    confirmPassword: '',
                    email: email,
                }}
                validationSchema={ResetPasswordSchema}
                onSubmit={handleResetPassword}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <InputField
                            type="password"
                            name="password"
                            lable={t('lable.newPassword')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            error={errors.password}
                            touched={touched.password}
                        />
                        <InputField
                            type="password"
                            name="confirmPassword"
                            lable={t('lable.confirmPassword')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.confirmPassword}
                            error={errors.confirmPassword}
                            touched={touched.confirmPassword}
                        />
                        <div>
                            <Button type="submit" disabled={isSubmitting}>
                                {t('button.submit')}
                            </Button>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    )
}
export default ResetPasswordForm
